const featuredWorksData = [
  {
    id: 1,
    img: "assets/img/case/case-1.jpg",
    title: "Telecom Sales & Activations",
    tagline: "Consistent activations for Internet, TV & Voice providers",
    excerpt: "Partner with leading Internet, TV, and Voice providers to deliver consistent activations through multiple channels.",
    subtitle:
      "We partner with leading Internet, TV, and Voice providers to deliver consistent activations through inbound and outbound channels.",
    capabilities: [
      "Internet/Fiber/DSL sales",
      "DIRECTV & TV bundles",
      "Small business packages",
      "Service qualification",
      "Cross-selling campaigns"
    ],
    category: "telecom",
  },
  {
    id: 2,
    img: "assets/img/case/case-2.jpg",
    title: "Call Center Operations",
    tagline: "Scalable solutions for sales, support & customer lifecycle",
    excerpt: "Scalable call center services with trained agents handling sales, support, and customer lifecycle tasks.",
    subtitle:
      "Scalable call center services with trained agents handling sales, support, and customer lifecycle tasks.",
    capabilities: [
      "Inbound & outbound sales",
      "Lead qualification",
      "Customer support",
      "Appointment setting",
      "Live transfers",
      "100% call recording with full QA oversight"
    ],
    category: "callcenter",
  },
  {
    id: 3,
    img: "assets/img/case/case-3.jpg",
    title: "Digital Marketing & Lead Generation",
    tagline: "Build predictable lead pipelines with modern funnels",
    excerpt: "Build predictable lead pipelines using modern digital funnels and multi-channel marketing strategies.",
    subtitle:
      "Build predictable lead pipelines using modern digital funnels and multi-channel marketing strategies.",
    capabilities: [
      "SEO (local & nationwide)",
      "Paid ads (Google, Meta, TikTok)",
      "Branded & unbranded social campaigns",
      "Landing page development",
      "Performance analytics",
      "Conversion optimization"
    ],
    category: "digital",
  },
  {
    id: 4,
    img: "assets/img/case/case-4.jpg",
    title: "Business Technology Solutions",
    tagline: "Modernize operations with cutting-edge technology",
    excerpt: "Help small and medium businesses modernize operations with cutting-edge technology solutions.",
    subtitle: "Helping small and medium businesses modernize operations with integrated technology solutions.",
    capabilities: [
      "CRM setup & integration",
      "Automations & workflow builders",
      "AI tools for sales teams",
      "Reputation management",
      "Digital identity & branding"
    ],
    category: "business",
  },
  {
    id: 5,
    img: "assets/img/case/case-5.jpg",
    title: "Compliance & QA Management",
    tagline: "Transparency, quality & regulatory compliance first",
    excerpt: "Built around transparency, quality, and regulatory compliance with TCPA-compliant workflows.",
    subtitle: "VectorTechSol is built around transparency, quality, and regulatory compliance with comprehensive QA management.",
    capabilities: [
      "TCPA-compliant workflows",
      "Call recording & data retention",
      "Script & SOP enforcement",
      "Daily/weekly QA audits",
      "Agent coaching programs",
      "Performance tracking & reporting"
    ],
    category: "compliance",
  },
];

export default featuredWorksData;
